import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useInput } from "react-admin";

import { Choice } from "types";

import * as S from "./ToggleCardGroupInput.styled";

interface ToggleButtonGroupInputProps {
  source: string;
  label: string;
  disabled?: boolean;
  choices: Choice[];
  defaultValue?: Choice["id"];
}

export const ToggleCardGroupInput = ({
  source,
  label,
  disabled,
  choices,
  defaultValue
}: ToggleButtonGroupInputProps) => {
  const { field } = useInput({ source, defaultValue: defaultValue ?? choices[0].id });

  return (
    <S.ToggleFormControl>
      <S.ToggleFormLabel>{label}</S.ToggleFormLabel>
      <S.ToggleCardGroup
        exclusive
        value={field.value}
        onChange={(_, value) => {
          if (value) {
            field.onChange(value);
          }
        }}
        color="primary"
        disabled={disabled}
      >
        {choices.map((choice) => (
          <S.ToggleCard key={choice.id} value={choice.id}>
            <S.ToggleCardAvatar>{choice.icon}</S.ToggleCardAvatar>
            <Box sx={{ width: "100%", ml: choice.icon ? 2 : 0 }}>
              <Typography align="left">{choice.name}</Typography>
              <S.ToggleHelperText align="left" variant="subtitle2" role="heading">
                {choice.helperText}
              </S.ToggleHelperText>
            </Box>
          </S.ToggleCard>
        ))}
      </S.ToggleCardGroup>
    </S.ToggleFormControl>
  );
};
